import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {AddDashboardWidgetDialog} from "../components/AddDashboardWidgetDialog";
import {WidgetType} from "../../../models/WidgetType";

export class AddDashboardWidgetService {

    public static id = "addDashboardWidgetService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {
    }

    public async open(): Promise<WidgetType> {
        const options: IModalSettings = {
            component: AddDashboardWidgetDialog,
            controllerAs: "ctrl",
            size: "md",
            resolve: {}
        };

        const modalInstance = this.$uibModal.open(options);
        return modalInstance.result;
    }
}
